module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/products-v2/single-product/nutrition/product-nutrition.component.css
// module id = ./src/app/products-v2/single-product/nutrition/product-nutrition.component.css
// module chunks = main